var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00139 0.701395L0.731135 6.39381C0.48984 6.61377 0.432931 6.90039 0.580895 7.16368C0.679917 7.33921 0.850645 7.45808 1.04983 7.48808C1.27177 7.52363 1.50282 7.44919 1.68493 7.28478C2.97108 6.1183 4.25723 4.95182 5.54224 3.78312L5.71525 3.62648C6.30938 3.08768 6.90351 2.54887 7.49992 2.00341C7.63878 2.13005 7.77764 2.25559 7.9165 2.38112L12.5887 6.6271C12.8494 6.86373 13.1078 7.10147 13.3752 7.33032C13.6552 7.57362 14.0855 7.55251 14.3324 7.28478C14.4451 7.1648 14.4998 7.0226 14.4998 6.87929C14.4998 6.70376 14.4189 6.52601 14.2585 6.38048L8.01666 0.716948C7.91308 0.622519 7.74691 0.495872 7.50333 0.500316C7.3235 0.494761 7.15505 0.562528 7.00139 0.701395Z",
    fill: "#2D2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.3bc70d6b23384176b70ea268b85f7ca3.svg";
export { ForwardRef as ReactComponent };